<template>
  <router-btn v-if="show" :text="$t('servicesystem.common_objects.job.hazard_analysis')" :icon="'mdi-file-alert'" :color="'primary'"
    :disabled="!jobId" outlined :loading="loading" :textbtn="textbtn" :large="large" :small="small" @Press="action">
  </router-btn>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import RouterBtn from "@/components/Buttons/RouterBtn.vue";

export default {
  name: "HazardAnalysisBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn },
  mixins: [clientAPI],

  data() {
    return {
      show: false,
      loading: false,
    };
  },

  created() {
    this.GetHazardAnalysisEnabled().then((data) => {
      this.show = data;
    });
  },

  methods: {
    action() {
      this.loading = true;
      this.GetHazardAnalysisLink(this.jobId, true).finally(() => {
        this.loading = false;
      });
    },
  },

  computed: {
    jobId() {
      return this.$route.params.jobId;
    },
  },

  watch: {},
};
</script>


<style lang="scss" scoped></style>
